exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-background{border-radius:5px}.success-background{border-radius:5px;background-color:#1be580}.grow-font-size{font-size:14px;padding:15px}", ""]);

// exports
